import { useState } from "react";

const useDrawer = (defaultOpen = false) => {
  const [open, setOpen] = useState(defaultOpen);

  const toggleDrawer = (newOpen) => {
    setOpen(newOpen);
  };

  return { open, toggleDrawer };
};

export default useDrawer;
